/**
 * Connects the double result selectors
 * @module app/views/BetDropdownViewAdapter
 */

/**
 * Map of message bus topic constants
 * @type {Object}
 * @public
 */
const MessageBusTopics = {
    ADD_BET: 'addBet',
    ADD_CAROUSEL_ELEMENT: 'homePage.carousel.add.icon',
    ADD_LEFT_NAV_ELEMENT: 'leftNav.add.item',
    APPLICATION_RESULTS_READY: 'Application.results.ready',
    APPS_TOASTER_CLOSE_CLICKED: 'appsToaster.close.clicked',
    APPS_TOASTER_OUTSIDE_TOASTER_CLICKED: 'appsToaster.outsideToaster.clicked',
    APPS_TOASTER_TOASTER_SHOW: 'appsToaster.toaster.show',
    APPS_TOASTER_TOASTER_SWIPED: 'appsToaster.toaster.swiped',
    APPS_TOASTER_TOASTER_TIMEOUT: 'appsToaster.toaster.timeout',
    APP_JS_DOM_READY: 'AppJs.domReady',
    APP_JS_HASH_CHANGE: 'AppJs.hashChange',
    APP_LAUNCHER_CLICKED: 'appLauncher.clicked',
    BACK_BUTTON: 'BackButton',
    BACK_BUTTON_HISTORY: 'BackButton.history',
    BANNER_SELECTION_ADDED: 'banner.selection.added',
    BANNERS_CAROUSEL_LINK_CLICKED: 'banners.carousel.link.clicked',
    BANNERS_CAROUSEL_INITIALISED: 'banners.carousel.initialised',
    BANNERS_CAROUSEL_SLIDE_CHANGED: 'banners.carousel.slideChanged',
    BETSLIP_ADAPTER_GET_BETS: 'BetslipAdapter.getBets',
    BETSLIP_ADAPTER_LEG_ADD: 'betslipAdapter.leg.add',
    BETSLIP_ADAPTER_LEG_REMOVE: 'betslipAdapter.leg.remove',
    BETSLIP_ADAPTER_SELECTION_UPDATE_COMPLETED: 'BetslipAdapter.selectionUpdateCompleted',
    BETSLIP_ADD_LEG_FAILURE: 'betslip.addLegFailure',
    BETSLIP_BET_PLACED: 'betslip.betPlaced',
    BETSLIP_CASHED_IN: 'betslip.cashedIn',
    BETSLIP_CASH_IN_STARTED: 'betslip.cashinStarted',
    BETSLIP_CLEAR_ALL: 'betslip.clearAll',
    BETSLIP_CLOSE_DRAWERS: 'betslip.closeDrawers',
    BETSLIP_EVENTS_BET_PLACE_FAILED: 'betslip.events.bet.place.failed',
    BETSLIP_INIT_COMPLETE: 'betslip.init.complete',
    BETSLIP_LEG_ADD: 'betslip.leg.add',
    BETSLIP_LEG_REMOVE: 'betslip.leg.remove',
    BETSLIP_OPENING: 'betslip.openingBetslip',
    BETSLIP_OPEN_BETSLIP_DRAWER: 'betslip.openBetslipDrawer',
    BETSLIP_OPEN_BETS_REFRESH: 'betslip.openBets.refresh',
    BETSLIP_OPEN_OPEN_BETS_DRAWER: 'betslip.openOpenBetsDrawer',
    BETSLIP_OPEN_TIP_ADVISOR_DRAWER: 'betslip.openTipAdvisorDrawer',
    BETSLIP_SHOW_BETSLIP_TAB: 'betslip.integration.tab.betslip.shown',
    BETSLIP_SHOW_OPENBETS_TAB: 'betslip.integration.tab.openbets.shown',
    BETSLIP_PRICE_FORMAT_SET: 'betslip.priceFormat.set',
    BETSLIP_REINIT: 'betslip.reInit',
    BETSLIP_REMOVE_LEG_FAILURE: 'betslip.removeLegFailure',
    BETSLIP_REMOVE_LEG_STARTED: 'betslip.removeLegStarted',
    BETSLIP_REUSE_SELECTIONS_SUCCESS: 'betslip.reuseSelectionsSucess',
    BETSLIP_SELECTION_ADDED: 'betslip.selection.added',
    BETSLIP_SLIP_CLEAR: 'betslip.slip.clear',
    BETSLIP_TAB_SET: 'betslip.tab.set',
    BETSLIP_ERROR_PROTOTYPE_RESTORED: 'error.prototype.restored',
    CASHOUT_ON_EVENT_PAGE_COUNTER: 'cashout.on.event.page.counter',
    CASHOUT_ON_EVENT_PAGE_SHOW: 'cashout.on.event.page.show',
    CLOSE_GAME: 'closeGame',
    CROSS_SELL_LAUNCH_GAME: 'crossSell.launchGame',
    CROSS_SELL_NAVIGATE: 'crossSell.navigate',
    CURRENT_PAGE: 'currentPage',
    DEFERRED_LOAD_MAGNIFIC_POPUP: 'deferred.load.magnificPopup',
    DEFERRED_LOAD_SEARCH: 'deferred.load.search',
    DETECTION_MARKUP_INIT_COMPLETE: 'detectionMarkupInitComplete',
    DEVICE_DETECTOR_DEVICE_DATA: 'DeviceDetector.deviceData',
    DEVICE_INFO: 'deviceInfo',
    DOM_READY_DETERMINED: 'domReadyDetermined',
    DO_INTERNAL_ROUTE: 'internalRoute',
    EMBEDDED_GAME_SHOW: 'embeddedGame.show',
    EVENTS_PAGE_LOADED: 'EventsPage.Loaded',
    EVENT_PAGE_OPENED: 'wh.sports.event.page.opened',
    FEEDBACK_USABILLA: 'feedback.open',
    GAME_DESTROY: 'game.destroy',
    GAME_GET_DEVICE_INFO: 'gameGetDeviceInfo',
    GAME_HIDDEN: 'game.hidden',
    GAME_IS_CLOSING: 'gameIsClosing',
    GAME_MINIMIZE: 'game.minimize',
    GAME_SHOWN: 'game.shown',
    GAME_SHOW_DEPOSIT: 'gameShowDeposit',
    GAME_SHOW_PAYMENTS: 'game.showPayments',
    GAME_SHOW_WITHDRAW: 'gameShowWithdraw',
    GAME_UPDATE_BALANCE: 'gameUpdateBalance',
    GET_JSON_RESOURCE_COMPLETED: 'getJSONResource.Completed',
    GOT_LOGIN_STATE: 'gotLoginState',
    HIDDEN_MARKETS_COMMAND_START: 'wh.common.command.ui.hidden.markets.widget.flow.start',
    HIDDEN_MARKETS_COMMAND_STOP: 'wh.common.command.ui.hidden.markets.widget.flow.stop',
    HIDDEN_MARKETS_COMMAND_STATE_GET: 'wh.common.command.ui.hidden.markets.widget.flow.state.get',
    HIDDEN_MARKETS_EVENT_START: 'wh.common.event.ui.hidden.markets.widget.flow.start',
    HIDDEN_MARKETS_EVENT_STOP: 'wh.common.event.ui.hidden.markets.widget.flow.stop',
    HIDDEN_MARKETS_EVENT_STATE_GET: 'wh.common.event.ui.hidden.markets.widget.flow.state.get',
    INTERNAL_ROUTE: 'internalRoute',
    JACKPOTS_DOM_READY: 'jackpots.domReady',
    JOCKEYS_TRAINERS_HIDE: 'jockeysTrainers.hide',
    JOCKEYS_TRAINERS_READY: 'jockeysTrainers.ready',
    JOCKEYS_TRAINERS_SHOW: 'jockeysTrainers.show',
    LIVESCORE_CONNECTION: 'livescore.connection',
    LIVESCORE_SUBSCRIBE: 'livescore.subscribe',
    LIVESCORE_UNSUBSCRIBE: 'livescore.unsubscribe',
    LIVESCORE_MESSAGE: 'livescore.message',
    ENHANCED_ODDS_CONNECTION: 'ehnancedOdds.connection',
    ENHANCED_ODDS_SUBSCRIBE: 'ehnancedOdds.subscribe',
    ENHANCED_ODDS_UNSUBSCRIBE: 'ehnancedOdds.unsubscribe',
    ENHANCED_ODDS_MESSAGE: 'ehnancedOdds.message',
    LOCAL_FORAGE: 'localForage',
    LOGIN_JS_LOGIN_DETERMINED: 'Loginjs.loginDetermined',
    MODEL_COMPOSER_PREGENERATE_MERGED_MODEL: 'ModelComposer.preGenerateMergedModel',
    MINUTE_MARKETS_SHOW: 'minutemarkets.show',
    MINUTE_MARKETS_HIDE: 'minutemarkets.hide',
    MINUTE_MARKETS_MOUNT_ENTRY_POINT: 'minutemarkets.mountEntryPoint',
    MINUTE_MARKETS_ENTRY_POINT_MOUNTED: 'minutemarkets.entryPointMounted',
    MINUTE_MARKETS_DESTROY: 'minutemarkets.destroy',
    PRELOADER_TOPIC: 'Preloader.message',
    PRELOADER_OPERATION_FULL_PAGE: 'fullPage',
    PRELOADER_OPERATION_FULL_PAGE_ERROR: 'fullPageError',
    MY_ACCOUNT_OVERLAY_SHOW_DEPOSIT: 'myaccount_overlay_show_deposit',
    MY_ACCOUNT_OVERLAY_SHOW_REGISTRATION: 'myaccount_overlay_show_registration',
    NATIVE_APP_BRIDGE_SEND_MESSAGE: 'NativeAppBridge.sendMessage',
    NATIVE_LOGIN: 'native.login',
    NATIVE_REMOVE_PLACEHOLDER: 'native.removePlaceholder',
    NAVIGATION_ARGS: 'navigation.args',
    NAVIGATION_BEFORE_PAGE_CHANGE: 'navigation.beforePageChange',
    NAVIGATION_CLICKED: 'navigationClicked',
    NAVIGATION_MOBILE_CLICKED: 'navigationMobileClicked',
    NAVIGATION_PAGE_CHANGED: 'navigation.pageChanged',
    NAVIGATION_QUERY_STRING: 'navigation.queryString',
    NAVIGATION_QUERY_STRING_SEARCH: 'navigation.queryString.search',
    NAVIGATION_SNIPPET_CHANGED: 'navigation.snippetChanged',
    NETWORK_TIME_DETERMINED: 'networkTimeDetermined',
    ON_ODDS_FORMAT_CHANGED: 'onOddsFormatChanged',
    OPEN_BUILD_YOUR_ODDS_MODAL: 'openBuildYourOddsModal',
    PUSH_PDS_DIFFUSION: 'push.PDSDiffusion',
    REFRESH_BALANCE: 'refreshBalance',
    REMOVE_BET: 'removeBet',
    REMOVE_WEB_SKELETON_OVERLAY: 'remove.webSkeletonOverlay',
    REQUEST_GOT_LOGIN_STATE: 'requestGotLoginState',
    SEARCH_CLOSE: 'search.close',
    SEARCH_EVENTS_LOAD_MORE: 'search.events.loadMore',
    SEARCH_EVENTS_SCROLL: 'search.events.scroll',
    SEARCH_EVENT_ITEMS_UPDATE: 'search.eventItems.update',
    SEARCH_EVENT_ITEMS_UPDATED: 'search.eventItems.updated',
    SEARCH_EVENT_RESULT_ITEM_CLICK: 'search.eventResultItem.click',
    SEARCH_ICON_BAR_ITEM_CLICK: 'search.iconBarItem.click',
    SEARCH_ICON_BAR_SCROLL: 'search.iconBar.scroll',
    SEARCH_ICON_BAR_UPDATE: 'search.iconBar.update',
    SEARCH_INPUT_CHANGE: 'search.input.change',
    SEARCH_LABELS_UPDATE: 'search.labels.update',
    SEARCH_OPEN: 'search.open',
    SEARCH_RECENT_SEARCHES_ITEM_CLICK: 'search.recentSearchesItem.click',
    SEARCH_RECENT_SEARCHES_UPDATE: 'search.recentSearches.update',
    SEARCH_REQUEST_FAILED: 'search.request.failed',
    SEARCH_REQUEST_START: 'search.request.start',
    SEARCH_REQUEST_START_LOAD_MORE: 'search.request.startLoadMore',
    SEARCH_REQUEST_SUCCESS: 'search.request.success',
    SEARCH_RESULT: 'searchResult',
    SEARCH_STATE_RESET: 'search.state.reset',
    SEARCH_WINDOW_RESIZE: 'search.window.resize',
    SELECTION_VIEW_ADAPTER_SELECTIONS_LOADED: 'SelectionViewAdapter.selectionsLoaded',
    SESSION_COMMAND_STATE_GET: 'wh.common.command.session.state.get',
    SESSION_EVENT_STATE_GET: 'wh.common.event.session.state.get',
    SESSION_EVENT_STATE_CHANGED: 'wh.common.event.session.state.changed',
    SET_BALANCE: 'setBalance',
    SHOW_DEPOSIT: 'showDeposit',
    SHOW_LOGIN: 'showLogin',
    SHOW_WITHDRAW: 'showWithdraw',
    SIDEBAR_NAVIGATION_GO_TO_URL: 'sidebarNavigation.goToUrl',
    SIDEBAR_NAVIGATION_READY: 'sidebarNavigation.ready',
    SIDEBAR_NAVIGATION_OPEN: 'sidebarNavigation.open',
    SIDEBAR_NAVIGATION_CLOSE: 'sidebarNavigation.close',
    STOP_ALL_PLAYERS: 'mediaplayers.stopAll',
    TOTE_HIDE: 'tote.hide',
    TOTE_READY: 'tote.ready',
    TOTE_SHOW: 'tote.show',
    INTERNATIONAL_RACING_HIDE: 'internationalRacing.hide',
    INTERNATIONAL_RACING_READY: 'internationalRacing.ready',
    INTERNATIONAL_RACING_SHOW: 'internationalRacing.show',
    TRANSLATION_LOCALE: 'translation.locale',
    TTF_BET_DETERMINED: 'ttfbetDetermined',
    WARNING_DISPLAYED: 'sportsbook.overlay.warning',
    WH_RADIO_STATUS: 'mediaplayers.whradio.status',
    WH_RADIO_PLAY: 'mediaplayers.whradio.play',
    WH_RADIO_STOP: 'mediaplayers.whradio.stop',
    WH_RADIO_MUTE: 'mediaplayers.whradio.mute',
    WH_RADIO_UNMUTE: 'mediaplayers.whradio.unmute',
    WH_RADIO_CHANNELS: 'mediaplayers.whradio.channels',
    XSELL_MICRO_NOTIFICATION_PROVIDER_COUNT_EXPIRED: 'xsellMicroNotificationProvider.count.expired',
    XSELL_MICRO_NOTIFICATION_PROVIDER_COUNT_UPDATE: 'xsellMicroNotificationProvider.count.update',
    XSELL_NOTIFICATIONS_CLOSE_CLICKED: 'xsellNotifications.close.clicked',
    XSELL_NOTIFICATIONS_FINISHED_CALCULATING_VISIBLE_NOTIFICATIONS:
        'xsellNotifications.finishedCalculatingVisibleNotifications',
    XSELL_NOTIFICATIONS_ICON_CLICKED: 'xsellNotifications.icon.clicked',
    XSELL_INJECT_BET_RECEIPT_APP: 'xsell.injectBetReceiptApp',
    XSELL_INTEGRATOR_BET_RECEIPT_INIT: 'wh.xsell.command.integrator.betreceipt.init',
    XSELL_INTEGRATOR_LOADED: 'wh.xsell.event.integrator.loaded',
    XSELL_INTEGRATOR_COMPONENT_INIT: 'wh.xsell.command.component.init',
    XSELL_INTEGRATOR_COMPONENT_SHUTDOWN: 'wh.xsell.command.component.shutdown',
    XSELL_INTEGRATOR_COMPONENT_UPDATE: 'wh.xsell.command.component.update',
    XSELL_INTEGRATOR_EVENT_INIT_SUCCESS: 'wh.xsell.event.component.init-success',
    XSELL_INTEGRATOR_EVENT_INIT_ERROR: 'wh.xsell.event.component.init-error',
    XSELL_INTEGRATOR_EVENT_SHUTDOWN_SUCCESS: 'wh.xsell.event.component.shutdown-success',
    XSELL_INTEGRATOR_EVENT_SHUTDOWN_ERROR: 'wh.xsell.event.component.shutdown-error',
    XSELL_INTEGRATOR_EVENT_UPDATE_SUCCESS: 'wh.xsell.event.component.update-success',
    XSELL_INTEGRATOR_EVENT_UPDATE_ERROR: 'wh.xsell.event.component.update-error',
    XSELL_INTEGRATOR_EVENT_SCROLL: 'wh.xsell.event.component.scroll.direction',
    SHOW_GOLDEN_RACE_OVERLAY: 'wh.sportsbook.overlay.show',
    PIH_WH_COMMON_EVENT_HEADER_LANGUAGE_SELECTED: 'wh.common.event.ui.header.language.selected',
    TRACKING_KIT_INSTALLATION_SUCCESSFUL: 'wh.sports.event.tracking-kit.installation.successful',
    TRACKING_KIT_INSTALLATION_FAILED: 'wh.sports.event.tracking-kit.installation.failed',
    TRACKING_EVENT_PARTIAL: 'wh.common.command.dli.tl.eventPartial',
    OPEN_LIVE_CHAT: 'live-person.open',
    BETTING_TV_CHANNEL: 'freeTvChannelChanged',
    START_POPULAR_BET_BUILDERS_HUB: 'wh.sb.widgetPopularBetBuilders.start',
    STOP_POPULAR_BET_BUILDERS_HUB: 'wh.sb.widgetPopularBetBuilders.stop',
};

export default MessageBusTopics;
